export default function DefaultOverlay({ module }) {
    return (
        <div className="p-4 my-4 bg-yellow-100 border-l-4 border-yellow-500 rounded">
            <h2 className="font-bold text-lg">
                Overlay inconnu : {module.overlay_name}
            </h2>
            <p className="text-gray-700">
                Aucun composant n’existe pour ce module.
            </p>
        </div>
    );
}
